import React from "react";
import "./scss/index.scss";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import * as ReactDOMClient from "react-dom/client";

const node = document.getElementById("root");
const root = ReactDOMClient.createRoot(node);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
